import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  getIngrediantsStatus,
  getIngrediantsError,
  getIngrediantsSuccess,
  getIngrediantsLoading,
  modifyIngrediant,
} from "../../../features/ingrediantSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import IngredientForm from "./ingrediantForm";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyIngrediant = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId } = useRestaurant();
  const data = location.state.ingrediant;
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getIngrediantsStatus);
  const error = useSelector(getIngrediantsError);
  const loading = useSelector(getIngrediantsLoading);
  const success = useSelector(getIngrediantsSuccess);

  const initialValues = {
    name: data.name,
    price: data.price,
    variations: data?.variations?.map(v => ({
      _id: v._id,
      price: v.price || 0
    })) || [],
    suppPrice: data.suppPrice || 0,
    outOfStock: data.outOfStock,
    visible: data.visible,
  };

  const handleFormSubmit = (values) => {
    const requestBody = {
      name: values.name,
      price: values.price,
      suppPrice: values.suppPrice,
      outOfStock: values.outOfStock,
      visible: values.visible,
      variations: values.variations,
      ...getImageFormFields(previewImage),
    };
    dispatch(
      modifyIngrediant({
        body: requestBody,
        ingrediantId: data._id,
        restaurantId,
      })
    );
  };

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      navigate("/ingrediants");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header title={t("headers.editIngredient")} subtitle={t("headers.editIngredientSub")} />
      <IngredientForm
        buttonText={t("common.edit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        loading={loading}
        image={data.image}
      />
    </Box>
  );
};

export default ModifyIngrediant;
